const LogoutButton = ({ onLogout = () => null }) => {
  const logout = onLogout();

  return (
    <button
      onClick={logout}
      className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-700"
    >
      Logout
    </button>
  );
};

export default LogoutButton;
